import { useEffect, useRef } from "react";
import { useUser } from "../auth/useUser";
import { useNotificationPrefs } from "./useNotificationPrefs";

// useNotificationSync hydrates the notification-prefs store from the
// server's User.notifications_on_complete / sound_on_complete once /me
// resolves (0027 P6). Mirrors useThemeSync: per-uid tracking so a
// sign-out + sign-in-as-different-user re-hydrates. Wired in App.tsx so
// it's always mounted while signed in.
export function useNotificationSync() {
  const { data: user } = useUser();
  const hydrate = useNotificationPrefs((s) => s.hydrate);
  const hydratedUid = useRef<string | null>(null);

  useEffect(() => {
    if (!user) return;
    if (hydratedUid.current === user.id) return;
    hydratedUid.current = user.id;
    hydrate({
      notificationsOnComplete: user.notifications_on_complete ?? false,
      soundOnComplete: user.sound_on_complete ?? false,
    });
  }, [user, hydrate]);
}
